import { useMemo } from 'react';
import useSpectrum from './useSpectrum';
const emptyData = { filters: {} };
export function useFilter(filterID) {
    const { filters } = useSpectrum(emptyData);
    return useMemo(() => filters.find((filter) => filter.name === filterID) || null, [filterID, filters]);
}
